export interface TrendArrowIconProps {
  color?: string;
}

export const UpIcon8px = ({ color = '#29845A' }: TrendArrowIconProps = {}) => {
  return (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_18114_1146)">
        <path d="M1 7L6.5 1.5M6.5 1.5H1.5M6.5 1.5V6.5" stroke={color} strokeWidth="1.5" />
      </g>
      <defs>
        <clipPath id="clip0_18114_1146">
          <rect width="8" height="8" fill="white" transform="matrix(0 -1 1 0 0 8)" />
        </clipPath>
      </defs>
    </svg>
  );
};
